<template>
    <div class="wrapper-editor-observation">
        <v-card class="pa-2 editor-background-observation">
            <div class="editor ma-2">
                <editor-content class="editor__content" :editor="editor" />
            </div>
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }" class="mt-4">
                <div class="menubar d-flex">
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.bold() }"
                        @click="commands.bold"
                        type="button"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_bold</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.italic() }"
                        @click="commands.italic"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_italic</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.underline() }"
                        @click="commands.underline"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_underline</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.strike() }"
                        @click="commands.strike"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>strikethrough_s</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.bullet_list() }"
                        @click="commands.bullet_list"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_list_bulleted</v-icon>
                    </v-btn>
                    <v-btn
                        class="menubar__button ma-1 pa-0"
                        :class="{ 'is-active': isActive.ordered_list() }"
                        @click="commands.ordered_list"
                        :color="color ? color : 'white'"
                        depressed
                        small
                    >
                        <v-icon>format_list_numbered</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="files"
                        class="menububble__button ma-1 pa-0"
                        :color="color ? color : 'white'"
                        depressed
                        small
                        for="file-observation-input"
                    >
                        <label for="file-observation-input">
                            <v-icon>attach_file</v-icon>
                        </label>
                        <input type="file" id="file-observation-input" class="custom-file-input" @change="files" :multiple="multipleFiles">
                    </v-btn>
                </div>
            </editor-menu-bar>
        </v-card>
    </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
    BulletList,
    ListItem,
    OrderedList,
    Bold,
    Italic,
    Strike,
    Underline,
    Placeholder
} from 'tiptap-extensions'

export default {
    name: 'editor-observation',
    components: {
        EditorContent,
        EditorMenuBar
    },
    props: ['value', 'button', 'files', 'color', 'background', 'multipleFiles'],
    data () {
        return {
            editor: null,
            content: '',
            editing: false
        }
    },
    beforeDestroy () {
        this.editor.destroy()
    },
    mounted () {
        this.editor = new Editor({
            extensions: [
                new BulletList(),
                new ListItem(),
                new OrderedList(),
                new Bold(),
                new Italic(),
                new Strike(),
                new Underline(),
                new Placeholder({
                    emptyEditorClass: 'is-editor-empty',
                    emptyNodeClass: 'is-empty',
                    emptyNodeText: this.$t('common.editorObservationEmptyNodeText'),
                    showOnlyWhenEditable: true,
                    showOnlyCurrent: true
                })
            ],
            onUpdate: ({ getHTML }) => {
                this.$emit('input', this.editor.getHTML())
            },
            content: ''
        })
        this.editor.setContent(this.value)
    },
    watch: {
        value () {
            if (this.editing === false) {
                if (!this.value) {
                    this.editor.setContent('')
                } else {
                    this.editor.setContent(this.value)
                }
                this.editing = true
            }
        }
    }
}
</script>
<style lang="scss">
.editor-background-observation {
    background-color: #E0E0E0 !important;
}

.wrapper-editor-observation{
    .editor{
        .editor__content{
            height: 100%;
        }

        width: 100%;
        line-height: 20px;
        min-height: 100px;

        .ProseMirror{
            height: 100%;
            outline-width: 0;

            p{
                margin: 0px
            }
        }

        p.is-editor-empty:first-child::before {
            content: attr(data-empty-text);
            float: left;
            color: #aaa;
            pointer-events: none;
            height: 100%;
            font-style: italic;
        }
    }
    #file-observation-input{
        display: none;
    }

    .menubar__button {
        &.is-active {
            &:before {
                opacity: 0.24;
            }
        }
    }
}
</style>
